export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-white text-3xl md:text-4xl"></i>
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
              移动端畅享观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              宅男视频已全面适配移动端浏览器，手机、平板打开即用，无需下载 APP。
              躺在床上、通勤路上随时打开观看，高清流畅不卡顿，宅男专属的移动观影体验。
              将宅男视频添加到手机桌面，即可像 APP 一样快速访问。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-primary-50 rounded-lg">
                <i className="ri-android-line text-primary-600"></i>
                <span className="text-sm font-medium text-foreground-800">安卓适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-secondary-50 rounded-lg">
                <i className="ri-apple-line text-secondary-600"></i>
                <span className="text-sm font-medium text-foreground-800">iOS 适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-accent-50 rounded-lg">
                <i className="ri-tablet-line text-accent-600"></i>
                <span className="text-sm font-medium text-foreground-800">平板适配</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}